import { reportBigQueryClick, reportMixpanelClick } from '../../../../utils/reporter';
import { LINKS } from '../constants';
import { bigQuery } from './bigQuery';
import { mixpanelInteractionEvent } from './mixPanel';

type LogoMakerLink = (typeof LINKS)[keyof typeof LINKS];

export const reportLogoMakerClick = (userId: number | undefined, link: LogoMakerLink) => {
    reportBigQueryClick(bigQuery(userId, link.bigQuery));
    reportMixpanelClick(mixpanelInteractionEvent(link.mixpanel));
};
